import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import get from 'lodash/get';

import Notification from '@jobcase/react_pattern_library/components/Notification';

import { clearNotification } from '../../redux/nodes/notification/actions';
import {
  getIsNotificationVisible,
  getNotificationVariant,
  getNotificationMessage,
  getNotificationPersist,
} from '../../redux/nodes/notification/selectors';

import { useAppContext, useSelector } from '../../utils/hooks';
import { GLOBAL_TOASTER_NOTIFICATION_TIMEOUT } from '../../constants';

const ToasterNotificationWrapper = styled.div`
  bottom: 0;
  left: 50%;
  position: fixed;
  transform: translateX(-50%);
  width: 100%;
  z-index: 9001;

  @media(min-width: ${({ theme }) => get(theme, 'breakpoint.md')}) {
    bottom: unset;
    max-width: 940px;
    position: fixed;
    top: 84px;
  }

  [class*="Notification__CloseWrapper-sc"] {
    margin: 0 0 0 20px;
    
    &:hover {
      cursor: pointer;
    }
  }
`;

const StyledToasterNotification = styled.div`
  height: fit-content;
  padding: 0 ${({ theme }) => get(theme, 'spacing.default')}px ${({ theme }) => get(theme, 'spacing.default')}px;
  width: 100%;

  @media(min-width: ${({ theme }) => get(theme, 'breakpoint.md')}) {
    padding: unset;
  }
`;

const StyledNotification = styled(Notification)`
  border-radius: ${({ theme }) => get(theme, 'spacing.cardBorderRadius')}px;
  padding: ${({ theme }) => get(theme, 'spacing.default')}px;

  svg {
    height: 22px;
    width: 22px;
  }
`;

const ToasterText = styled.div`
  display: inline-block;
`;

const GlobalToasterNotification = () => {
  const dispatch = useDispatch();
  const { isMobile } = useAppContext();
  const isVisible = useSelector(getIsNotificationVisible);
  const variant = useSelector(getNotificationVariant);
  const message = useSelector(getNotificationMessage);
  const persist = useSelector(getNotificationPersist);

  const handleToasterNoficiationClose = () => {
    dispatch(clearNotification());
  };

  useEffect(() => {
    let timer = null;
    if (isVisible && !persist) {
      timer = setTimeout(handleToasterNoficiationClose, GLOBAL_TOASTER_NOTIFICATION_TIMEOUT);
    }
    return () => {
      clearTimeout(timer);
    };
  }, [isVisible, persist]);

  return (
    <>
      {isVisible && (
        <ToasterNotificationWrapper>
          <StyledToasterNotification>
            <StyledNotification
              onClick={handleToasterNoficiationClose}
              hideCloseButton={false}
              variant={variant}
              isMobile={isMobile}
            >
              <ToasterText>
                {message}
                &nbsp;
              </ToasterText>
            </StyledNotification>
          </StyledToasterNotification>
        </ToasterNotificationWrapper>
      )}
    </>
  );
};

export default GlobalToasterNotification;
